/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConsigneeTourDetailResponseV3 } from '../models/consignee-tour-detail-response-v-3';
import { ConsigneeToursArrayResponseV3 } from '../models/consignee-tours-array-response-v-3';
import { getConsigneeAddonsToursV3 } from '../fn/tours-v-3/get-consignee-addons-tours-v-3';
import { GetConsigneeAddonsToursV3$Params } from '../fn/tours-v-3/get-consignee-addons-tours-v-3';
import { getConsigneeAddonsTourV3 } from '../fn/tours-v-3/get-consignee-addons-tour-v-3';
import { GetConsigneeAddonsTourV3$Params } from '../fn/tours-v-3/get-consignee-addons-tour-v-3';
import { getConsigneeAddonsTourVirtualArticlesV3 } from '../fn/tours-v-3/get-consignee-addons-tour-virtual-articles-v-3';
import { GetConsigneeAddonsTourVirtualArticlesV3$Params } from '../fn/tours-v-3/get-consignee-addons-tour-virtual-articles-v-3';
import { TourVirtualArticlesResponse } from '../models/tour-virtual-articles-response';

@Injectable({ providedIn: 'root' })
export class ToursV3Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConsigneeAddonsToursV3()` */
  static readonly GetConsigneeAddonsToursV3Path = '/organization-sites/{organizationSiteKey}/consignee/tours/';

  /**
   * Get consignee tours (v3).
   *
   * Get tours for consignee with enhanced pagination and sorting.
   * Wraps the basic backend endpoint and enriches each tour with a qsStatus
   * (traffic light) aggregated from its delivery notes' article comparison statuses,
   * and with a deliveryNoteBundleGroups list noting which of the tour's delivery
   * notes belong to which bundle group (Mappengruppe).
   * All filters (filterProperty/filterValue, direct field filters, search) are
   * passed through to the basic backend.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeAddonsToursV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeAddonsToursV3$Response(params: GetConsigneeAddonsToursV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeToursArrayResponseV3>> {
    const obs = getConsigneeAddonsToursV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get consignee tours (v3).
   *
   * Get tours for consignee with enhanced pagination and sorting.
   * Wraps the basic backend endpoint and enriches each tour with a qsStatus
   * (traffic light) aggregated from its delivery notes' article comparison statuses,
   * and with a deliveryNoteBundleGroups list noting which of the tour's delivery
   * notes belong to which bundle group (Mappengruppe).
   * All filters (filterProperty/filterValue, direct field filters, search) are
   * passed through to the basic backend.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeAddonsToursV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeAddonsToursV3(params: GetConsigneeAddonsToursV3$Params, context?: HttpContext): Observable<ConsigneeToursArrayResponseV3> {
    const resp = this.getConsigneeAddonsToursV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsigneeToursArrayResponseV3>): ConsigneeToursArrayResponseV3 => r.body)
    );
  }

  /** Path part for operation `getConsigneeAddonsTourV3()` */
  static readonly GetConsigneeAddonsTourV3Path = '/organization-sites/{organizationSiteKey}/consignee/tours/{tourKey}';

  /**
   * Get a single consignee tour (v3).
   *
   * Get a single tour for a consignee by its key. Wraps the basic backend
   * endpoint and enriches every delivery note of the tour with an optional
   * bundleGroupKey (Mappengruppenkey) noting which bundle group (Mappengruppe)
   * the delivery note belongs to. The bundleGroupKey is read from the
   * denormalized addons data in a single ArangoDB roundtrip, so no extra
   * basic-backend calls are made. Delivery notes that do not belong to a
   * group carry no bundleGroupKey.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeAddonsTourV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeAddonsTourV3$Response(params: GetConsigneeAddonsTourV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeTourDetailResponseV3>> {
    const obs = getConsigneeAddonsTourV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a single consignee tour (v3).
   *
   * Get a single tour for a consignee by its key. Wraps the basic backend
   * endpoint and enriches every delivery note of the tour with an optional
   * bundleGroupKey (Mappengruppenkey) noting which bundle group (Mappengruppe)
   * the delivery note belongs to. The bundleGroupKey is read from the
   * denormalized addons data in a single ArangoDB roundtrip, so no extra
   * basic-backend calls are made. Delivery notes that do not belong to a
   * group carry no bundleGroupKey.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeAddonsTourV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeAddonsTourV3(params: GetConsigneeAddonsTourV3$Params, context?: HttpContext): Observable<ConsigneeTourDetailResponseV3> {
    const resp = this.getConsigneeAddonsTourV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsigneeTourDetailResponseV3>): ConsigneeTourDetailResponseV3 => r.body)
    );
  }

  /** Path part for operation `getConsigneeAddonsTourVirtualArticlesV3()` */
  static readonly GetConsigneeAddonsTourVirtualArticlesV3Path = '/organization-sites/{organizationSiteKey}/consignee/tours/{tourKey}/virtual-articles';

  /**
   * Get all articles of a consignee tour (v3).
   *
   * Return all articles of a tour's delivery notes, flat and combined. This
   * is the tour pendant of the bundle group Gesamtliste (virtual articles),
   * but WITHOUT any grouping or summing: every article of every delivery note
   * of the tour is returned as-is (same shape as the normal articles endpoint,
   * including the QS traffic light, ASN metadata and notes). In addition, each
   * article carries the delivery note it belongs to via deliveryNoteKey and its
   * Lieferscheinnummer via deliveryNoteNumber. The tour's delivery notes are
   * resolved from the basic backend; the article enrichment is a single
   * ArangoDB roundtrip.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeAddonsTourVirtualArticlesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeAddonsTourVirtualArticlesV3$Response(params: GetConsigneeAddonsTourVirtualArticlesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<TourVirtualArticlesResponse>> {
    const obs = getConsigneeAddonsTourVirtualArticlesV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all articles of a consignee tour (v3).
   *
   * Return all articles of a tour's delivery notes, flat and combined. This
   * is the tour pendant of the bundle group Gesamtliste (virtual articles),
   * but WITHOUT any grouping or summing: every article of every delivery note
   * of the tour is returned as-is (same shape as the normal articles endpoint,
   * including the QS traffic light, ASN metadata and notes). In addition, each
   * article carries the delivery note it belongs to via deliveryNoteKey and its
   * Lieferscheinnummer via deliveryNoteNumber. The tour's delivery notes are
   * resolved from the basic backend; the article enrichment is a single
   * ArangoDB roundtrip.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeAddonsTourVirtualArticlesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeAddonsTourVirtualArticlesV3(params: GetConsigneeAddonsTourVirtualArticlesV3$Params, context?: HttpContext): Observable<TourVirtualArticlesResponse> {
    const resp = this.getConsigneeAddonsTourVirtualArticlesV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TourVirtualArticlesResponse>): TourVirtualArticlesResponse => r.body)
    );
  }

}
